import BloodPressureTooltip from './BloodPressureTooltip';

export default BloodPressureTooltip;
